import { render, staticRenderFns } from "./AppTipsMenu.vue?vue&type=template&id=d0faa3d6&scoped=true"
import script from "./AppTipsMenu.vue?vue&type=script&lang=js"
export * from "./AppTipsMenu.vue?vue&type=script&lang=js"
import style0 from "./AppTipsMenu.vue?vue&type=style&index=0&id=d0faa3d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0faa3d6",
  null
  
)

export default component.exports